import React from "react";
import PropTypes from "prop-types";
import "./Aresure.css";

const DeletePopup = ({ isOpen, setisOpen, handleDelete, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      onClick={() => setisOpen(false)}
      role="dialog"
      aria-labelledby="delete-modal-title"
      aria-describedby="delete-modal-description"
    >
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="modal-title">Are you sure you want to delete?</h2>

        <div className="modal-buttons">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="delete-btn" onClick={handleDelete}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

DeletePopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setisOpen: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DeletePopup;
